export const ENTER_FULL_SCREEN = 'screen/ENTER_FULL_SCREEN';
export const EXIT_FULL_SCREEN = 'screen/EXIT_FULL_SCREEN';